import features from 'Cloud/Application/FeaturesEs6';
import { IS_PHONE_BROWSER, IS_PUBLIC } from 'reactApp/appHelpers/configHelpers';

export const isUploadResumeAvailabe = !IS_PUBLIC && !IS_PHONE_BROWSER && features.isFeature('upload-resumable');
